import script from "./ProjectManageUploadSettingPlaybackChannelSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectManageUploadSettingPlaybackChannelSection.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectManageUploadSettingPlaybackChannelSection.vue?vue&type=style&index=0&id=1c673ea6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c673ea6"]])

export default __exports__